import React,{useState} from 'react'
import InputMask from 'react-input-mask'

import '../css/modal.css'

export const NumberInput=()=>{
    const [inputValue, setInputValue] = useState('+380');
    const [trueInputValue, setTrueInputValue] = useState('');
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value)
    };
    
    return(
        <div className="mb-3">
            <label htmlFor="inputName" className="form-label">tel number:{inputValue.slice(4)}</label><br/>
            <div className="input-container">
                
               
            </div>
            <InputMask 
                style={{border:`${inputValue.length>=5 ? '2px solid black' : '1px solid #ccc'}`}} 
                value={inputValue} onChange={handleInputChange} 
                mask="+380 (999) 999-99-99"
                
                className={` custom-input`}
                required
            />    
            <div className="invalid-feedback">
                Please enter your tel number
            </div>
        </div>
    )
}